import config from "../config/app";

/**
 * Tracks an event for Google Tag Manager.
 *
 * @param {string} event - The name of the event.
 * @param {Array.<{key: string, value: any}>} eventData - An array of key-value pairs describing the event.
 */
export const trackEvent = (event, eventData) => {
  if (config.gtmCode) {
    window.dataLayer.push({
      event,
      ...eventData,
    });
  }
};

export default trackEvent;
